import { useTranslation } from 'react-i18next'

import type { ProtectiveOrderModeId } from '../types'

const buildZeroPlaceholder = (decimals: number | undefined): string => {
  const safeDecimals = typeof decimals === 'number' && decimals > 0 ? decimals : 0
  if (safeDecimals === 0) return '0'
  return `0.${'0'.repeat(safeDecimals)}`
}

export const useProtectiveOrder = (priceDecimals: number | undefined) => {
  const { t } = useTranslation()

  const dropdownOptions: { id: ProtectiveOrderModeId; name: string }[] = [
    { id: 'Price', name: t('Portfolio.Price') },
    { id: 'Amount', name: t('Portfolio.Amount') },
    { id: 'Distance', name: t('Portfolio.Distance') },
  ]

  const placeholdersById: Record<ProtectiveOrderModeId, string> = {
    Price: buildZeroPlaceholder(priceDecimals),
    Amount: buildZeroPlaceholder(2),
    Distance: buildZeroPlaceholder(0),
  }

  return { dropdownOptions, placeholdersById }
}
